const HOST = new URL(document.URL).origin;

export default HOST;
